/**
 * Retries an async operation up to `attempts` times, waiting `delayMs` between
 * each attempt. On mobile, getUserMedia and AudioContext.resume() can fail
 * transiently on the first call even after the user grants permission, so a
 * small number of automatic retries avoids a confusing "denied" result.
 */
export async function withRetry<T>(
  fn: () => Promise<T>,
  attempts: number,
  delayMs: number
): Promise<T> {
  let lastErr: unknown;
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      if (i < attempts - 1) {
        await new Promise(r => setTimeout(r, delayMs));
      }
    }
  }
  throw lastErr;
}
